<template>
    <div class="header-progress-bar">
        <ul>
            <li v-for="(item, index) in stepsArray" :key="index" :class="{'done': index < currentStep, current: index == currentStep}">
                <a href="#" @click="setStep(index)">
                    <i v-if="index < currentStep" class="fas fa-check"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>

  export default {
    name: 'HeaderProgressBar',
    data () {
      return {

      };
    },
    methods: {
      setStep(index) {
        this.currentStep = index;
      }

    },
    computed: {
      stepsArray () {
        return Array.from(Array(this.totalSteps).keys());
      },
      currentStep: {
        get () {
          return this.$store.getters['header/progress'];
        },
        set (value) {
          this.$store.commit('header/progress', value);
        }
      },
      totalSteps: {
        get () {
          return this.$store.getters['header/totalSteps'];
        },
        set (value) {
          this.$store.commit('header/totalSteps', value);
        }
      }
    }
  };

</script>

<style>
</style>